import "/tmp/tmp-8023-8muGggC0250G/1947338157d10/index.module.css";
export default {"sider":"index-module__sider___2-j8e"};